<script setup>
import { useRequestURL } from "#app";
import { useRoute } from "vue-router";
const route = useRoute();
defineProps({
  language: {
    type: String,
    default: "en"
  },
  country: {
    type: String,
    default: "gb"
  }
});
const localesList = [
  {
    languageCode: "en",
    countryCode: "gb",
    languageName: "English",
    countryName: "United Kingdom"
  },
  {
    languageCode: "fr",
    countryCode: "fr",
    languageName: "Fran\xE7ais",
    countryName: "France"
  },
  {
    languageCode: "de",
    countryCode: "de",
    languageName: "Deutsch",
    countryName: "Deutschland"
  },
  {
    languageCode: "nl",
    countryCode: "nl",
    languageName: "Nederlands",
    countryName: "Nederland"
  },
  {
    languageCode: "it",
    countryCode: "it",
    languageName: "Italiano",
    countryName: "Italia"
  },
  {
    languageCode: "es",
    countryCode: "es",
    languageName: "Espa\xF1ol",
    countryName: "Espa\xF1a"
  },
  {
    languageCode: "pt",
    countryCode: "pt",
    languageName: "Portugu\xEAs",
    countryName: "Portugal"
  }
];
const localisedUrl = (locale) => {
  let path = route.path;
  if (path.startsWith("/")) {
    path = path.substring(1);
  }
  const segments = path.split("/");
  if (segments.length && segments[0] && segments[0].match(/^[a-z]{2}-[a-z]{2}$/)) {
    segments.shift();
  }
  path = segments.join("/");
  return `${useRequestURL().origin}/${locale.languageCode}-${locale.countryCode}/${path}`;
};
</script>

<template>
    <div class="locales-list">
        <div v-for="locale of localesList" :key="locale.countryName">
            <NuxtLink
                :to="localisedUrl(locale)"
                :title="locale.languageName"
                :hreflang="`${locale.languageCode}-${locale.countryCode.toUpperCase()}`"
                :class="[
  `${language}-${country}` === `${locale.languageCode}-${locale.countryCode}` && 'font-bold'
]"
            >
                {{ locale.languageName }}
            </NuxtLink>
        </div>
    </div>
</template>

<style scoped>
.locales-list {
  @apply grid-cols-2 mx-4 grid gap-x-2 w-full h-auto bg-white relative md:mx-auto;
}
.locales-list div {
  @apply py-3 px-1 border-b-[1px] border-solid border-zinc-200 w-full hover:border-sky-400 transition-all duration-300 ease-in-out;
}
.locales-list a {
  @apply block py-1 px-1 text-zinc-800 hover:text-sky-400 text-base w-full transition-all duration-300 ease-in-out;
}
</style>
